import {ComponentRef, Directive, ElementRef, inject, Signal, viewChild, WritableSignal} from "@angular/core";
import {View} from "./view";
import {NavigationService} from './navigation.service';

export enum PageAlignment {
    LEFT,
    RIGHT,
    TOP,
    BOTTOM,
    FULL
}

export interface PageComponentContainer {
    pageSpec: PageSpec;
    geometry: WritableSignal<PageGeometry>;

    openPageComponent(): void;

    closePageComponent(): void;
}

export abstract class PageLayout {

    // Accessed by the page container to manage swipe-to-close
    public abstract pageScrollerER: Signal<ElementRef | undefined>;
}

@Directive()
export class Page extends View {
    public navigationService: NavigationService = inject(NavigationService);

    public pageLayout: Signal<PageLayout | undefined> = viewChild(PageLayout);

    // Injected by the navigation service for managing page dismissal
    componentRef: ComponentRef<Page>;

    // Injected by the page container for managing page dismissal
    containerComponentRef?: ComponentRef<PageComponentContainer>;

    public async dismiss(results?: any, failure: boolean = false, popHistory: boolean = true): Promise<boolean> {
        return this.navigationService.dismissPage(this, results, failure, popHistory);
    }

    // noinspection JSUnusedLocalSymbols
    onActive(): void {
    }

    // noinspection JSUnusedLocalSymbols
    onInactive(): void {
    }

    // noinspection JSUnusedLocalSymbols
    async onWillDismissPage(results?: any): Promise<boolean> {
        return true;
    }

    // noinspection JSUnusedLocalSymbols
    onDidDismissPage?(results?: any): void {
    }
}

export class PageGeometry {
    public alignment?: PageAlignment = PageAlignment.BOTTOM;
    public pillarboxedOnMobile?: "mobile" | "none" = "mobile";
    public pillarboxedOnDesktop?: "mobile" | "desktop" | "double-mobile" | "none" = "mobile";
    public width?: string;
    public height?: string;
    public disableSwipe?: boolean;
}

export class ComparablePageGeometry extends PageGeometry {
    public equals(geometry: PageGeometry): boolean {
        return this.alignment === geometry.alignment &&
            this.pillarboxedOnMobile === geometry.pillarboxedOnMobile &&
            this.pillarboxedOnDesktop === geometry.pillarboxedOnDesktop &&
            this.width === geometry.width && this.height === geometry.height &&
            this.disableSwipe === geometry.disableSwipe;
    }
}

export class PageSpec {
    public geometry: PageGeometry;

    constructor(public componentRef: ComponentRef<Page>,
                geometry: PageGeometry) {
        this.geometry = Object.assign(new PageGeometry(), geometry || {});
    }
}
